import { Link } from "react-router-dom";
import { Compass, Home, LayoutDashboard, LifeBuoy } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function NotFound() {
  const { user } = useAuth();
  const isCustomer = (user?.account_type || user?.role) === "customer";
  const dashHref = isCustomer ? "/portal" : "/app";

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[#FAFAFA]"
         data-testid="not-found-page">
      <div className="max-w-md text-center">
        <Compass className="w-12 h-12 mx-auto text-emerald-600" />
        <h1 className="font-display text-3xl font-bold mt-4">Page not found</h1>
        <p className="text-slate-600 mt-2">
          The page you're looking for doesn't exist or has moved. Let's get you back on track.
        </p>
        <div className="mt-6 flex flex-wrap gap-2 justify-center">
          <Link to="/" data-testid="404-home"
                 className="px-4 py-2 rounded-lg btn-brand font-medium text-sm inline-flex items-center gap-2">
            <Home className="w-4 h-4" /> Home
          </Link>
          {user && (
            <Link to={dashHref} data-testid="404-dashboard"
                   className="px-4 py-2 rounded-lg border border-slate-300 hover:bg-slate-50 text-sm inline-flex items-center gap-2">
              <LayoutDashboard className="w-4 h-4" /> Dashboard
            </Link>
          )}
          <Link to="/support" data-testid="404-support"
                 className="px-4 py-2 rounded-lg border border-slate-300 hover:bg-slate-50 text-sm inline-flex items-center gap-2">
            <LifeBuoy className="w-4 h-4" /> Support
          </Link>
        </div>
      </div>
    </div>
  );
}
